// @file For linkings on tldraw canvas

import { vDel, vSet } from '@@/bits/vue'
import type { WhiteboardLinkingLink } from '@@/bits/whiteboard_linking'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWhiteboardLinkingStore = defineStore('whiteboardLinking', () => {
  // Links
  const linkings = ref<Record<string, WhiteboardLinkingLink>>({})

  async function upsertLinking(shapeId: string, linking: WhiteboardLinkingLink): Promise<void> {
    vSet(linkings.value, shapeId, linking)
  }

  async function deleteLinking(shapeId: string): Promise<void> {
    if (linkings.value[shapeId] != null) {
      vDel(linkings.value, shapeId)
    }
  }

  function checkIfLinkingExists(shapeId: string): boolean {
    return linkings.value[shapeId] != null
  }

  // Panel

  const xLinkingPanel = ref(false)
  const xLinkingPanelShapeId = ref<string | null>(null)

  function openLinkingPanel(shapeId: string): void {
    xLinkingPanel.value = true
    xLinkingPanelShapeId.value = shapeId
  }
  function closeLinkingPanel(): void {
    xLinkingPanel.value = false
    xLinkingPanelShapeId.value = null
  }

  return {
    // Links
    // State
    linkings,
    // Actions
    upsertLinking,
    deleteLinking,
    checkIfLinkingExists,

    // Panel
    // State
    xLinkingPanel,
    xLinkingPanelShapeId,
    // Actions
    openLinkingPanel,
    closeLinkingPanel,
  }
})
